import { ActionFromReducer, combineReducers } from 'redux';

import { authReducer } from './auth/reducer';
import { configReducer } from './config/reducer';
import { modalReducer } from './modal/reducer';
import { navReducer } from './nav/reducer';
import { oauthReducer } from './oauth/reducer';
import { userReducer } from './user/reducer';

const reducerMap = {
  auth: authReducer,
  config: configReducer,
  modal: modalReducer,
  nav: navReducer,
  oauth: oauthReducer,
  user: userReducer,
};

export const rootReducer = combineReducers(reducerMap);

export type RootState = ReturnType<typeof rootReducer>;

export type RootActions = ActionFromReducer<typeof rootReducer>;
